"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fx_1 = require("./fx");
const commonParamBuilder_1 = require("./commonParamBuilder");
const statManager_1 = require("./statManager");
class WaLogger {
    constructor() {
        this.commonParams = {};
        this.statManager = new statManager_1.default();
    }
    init(host, path) {
        this.host = host;
        this.path = path;
        this.isDisabled = false;
    }
    getRuleManager() {
        return this.statManager;
    }
    setCommonParams(commonParams) {
        this.commonParams = Object.assign({}, this.commonParams, commonParams);
        this.statManager.setParams(this.commonParams);
    }
    getCommonParams() {
        return this.commonParams;
    }
    log(params = {}, ruleKey) {
        const logParams = ruleKey ? this.statManager.toLogs(ruleKey, params) :
            Object.assign({}, this.commonParams, params, { uc_param_str: commonParamBuilder_1.ucParamStr });
        if (this.isDisabled) {
            return;
        }
        const url = `${this.host}/${this.path}?${fx_1.getCommonParamsStr(logParams)}`;
        try {
            const result = navigator.sendBeacon(url, '');
            if (!result) { // 兼容sendBeacon打点失败
                new Image().src = url;
            }
        }
        catch (ex) {
            new Image().src = url;
        }
    }
    disable() {
        this.isDisabled = true;
    }
    enable() {
        this.isDisabled = false;
    }
}
exports.WaLogger = WaLogger;
class LoggerFactory {
    constructor() {
        this.loggers = {};
        this.loggerFactorys = {};
    }
    init(ctx) {
        ctx.pvId = fx_1.generateUUID();
        Object.keys(this.loggers).forEach((key) => {
            this.loggerFactorys[key](this.loggers[key], ctx);
        });
    }
    setLogger(name, loggerFactory) {
        this.loggers[name] = new WaLogger();
        this.loggerFactorys[name] = loggerFactory;
    }
    getLogger(name) {
        return this.loggers[name];
    }
}
exports.LoggerFactory = LoggerFactory;
exports.BuildInLoggers = {
    log: 'log',
    pv: 'pv',
    action: 'action',
    performance: 'performance',
};
const WA = new LoggerFactory();
function frontPageLogger(logger, ctx) {
    logger.init(ctx.host, 'collect');
    const params = fx_1.getQueryParams();
    const statInfo = ctx.statInfo || {};
    const global = window;
    statInfo.domain = window.location.host;
    statInfo.is_offline_pack = !!global.IS_OFFLINE_PACK;
    statInfo.local_ver = global.LOCAL_STORY_VER || '';
    statInfo.pv_id = ctx.pvId;
    statInfo.quick = params.quick;
    statInfo.tpl_abtag = global.TPL_AB_TAG || 'online';
    statInfo.pg_path = window.location.pathname;
    statInfo.webkit_type = navigator.userAgent.indexOf('AndroidWebkit') > -1 ? 'android' : '';
    logger.getRuleManager().setParams(statInfo);
    logger.getRuleManager().setRule('frontPageDefault', {
        params: {
            _extend: [
                '~domain',
                '~is_offline_pack',
                '~local_ver',
                '~pv_id',
                '~quick',
                '~tpl_abtag',
                '~pg_path',
                '~webkit_type',
                '~ver',
                '~sver',
                '~pf',
                '~ut',
                '~people_id',
                '~item_type',
                '~daoliu_type',
                '~content_type',
                '~media_type',
                '~ready_state',
                '~is_wemedia',
                '~co_coop',
                '~source',
                '~site',
                '~is_push',
                '~item_id',
                '~ch_id1',
                '~ch_id2',
                '~cate_id',
                '~ct_lang',
                '~article_id',
                '~client',
                '~ad_enable',
                '~index_is_cp',
                '~comment_stat',
                '~comment_type',
                '~list_article_from',
            ],
        },
    });
    const filterStatInfo = logger.getRuleManager().toLogs('frontPageDefault');
    const commonParams = Object.assign(filterStatInfo, {
        appid: ctx.appId,
        ct: 'jslog',
        lt: 'front-page',
        ctm: Date.now(),
        referrer: fx_1.getReferrer(),
    });
    logger.setCommonParams(commonParams);
    return logger;
}
exports.frontPageLogger = frontPageLogger;
WA.setLogger(exports.BuildInLoggers.log, (logger, ctx) => {
    frontPageLogger(logger, ctx);
    return logger;
});
WA.setLogger(exports.BuildInLoggers.pv, (logger, ctx) => {
    frontPageLogger(logger, ctx);
    logger.setCommonParams({
        ev_ct: 'pv',
    });
    return logger;
});
WA.setLogger(exports.BuildInLoggers.action, (logger, ctx) => {
    frontPageLogger(logger, ctx);
    logger.setCommonParams({
        ev_ct: 'action',
    });
    return logger;
});
WA.setLogger(exports.BuildInLoggers.performance, (logger, ctx) => {
    frontPageLogger(logger, ctx);
    logger.setCommonParams({
        host: window.location.host,
    });
    return logger;
});
exports.WaPv = WA.getLogger(exports.BuildInLoggers.pv);
exports.WaAction = WA.getLogger(exports.BuildInLoggers.action);
exports.WaPerformance = WA.getLogger(exports.BuildInLoggers.performance);
exports.WaLog = WA.getLogger(exports.BuildInLoggers.log);
exports.default = WA;
//# sourceMappingURL=data:application/json;base64,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